<i18n>
	{
		"en": {
		},
		"ru": {
			"title": "Действия",
            "change_rate": "Изменить оценку",
            "my": "Показывать моё мнение",
            "community": "Показывать мнение сообщества"
		}
	}
</i18n>

<template>

    <modal-content
        class="characteristics-actions-modal"
        :class="rootClasses"
        small-bottom
        no-padding-body>

        <template #title>
            {{ $t('title') }}
        </template>

        <template #body>
            <div class="characteristics-actions">
                <div class="characteristics-actions__container">
                    <PopupCheckbox
                        type="radio"
                        value="community"
                        v-model="opinionTypeValue">
                        {{ $t('community') }}
                    </PopupCheckbox>

                    <PopupCheckbox
                        type="radio"
                        value="my"
                        v-model="opinionTypeValue" >
                        {{ $t('my') }}
                    </PopupCheckbox>

                    <div class="characteristics-actions__delimiter"></div>

                    <PopupCheckbox
                        readonly
                        @change.native="onChangeRate">
                        {{ $t('change_rate') }}
                    </PopupCheckbox>
                </div>
            </div>
        </template>
    </modal-content>

</template>

<script>
import ModalContent from '@/components/modal/ModalContent'
import PopupCheckbox from '@/components/ui/PopupCheckbox'

export default {
    name: 'CharacteristicsActions',
    components: {
        ModalContent,
        PopupCheckbox
    },
    props: {
        opinionType: {
            type: String,
            default: ''
        },
        eventName: {
            type: String,
            default: ''
        },
        isTooltip: {
            type: Boolean,
            default: false
        },
        block: {
            type: String,
            default: ''
        }
    },
    computed: {
        rootClasses() {
            return {
                'characteristics-actions-modal_tooltip': this.isTooltip
            }
        },
        opinionTypeValue: {
            get() {
                return this.opinionType
            },
            set(value) {
                this.$bus.$emit(this.eventName, value)
                this.hide()
            }
        }
    },
    methods: {
        hide() {
            this.$modal.hide()
        },
        onChangeRate() {
            this.$authEmit('open-popup-rate', this.block)
            this.hide()
        }
    }
}
</script>

<style lang="less">
.characteristics-actions {
    &-modal {
        padding-right: 0;
        padding-left: 0;

        max-width: none;

        &__title {
            .page-padding();
        }

        &_tooltip {
            background-color: @color-white;
            border-radius: rem(3);
            box-shadow: 0 rem(3) rem(16) rgba(0, 0, 0, 0.08);

            height: auto;
            max-height: 65vh;

            position: relative;
            z-index: 100;

            overflow: hidden;
            transform-origin: top;

            @{desktop} & {
                width: rem(340);

                top: rem(7);
            }
        }
    }

    &__delimiter {
        padding-top: rem(12);
        padding-bottom: rem(15);

        &:after {
            content: '';
            display: block;

            background-color: @color-gray-white;

            height: rem(1);
            width: 100vw;

            position: absolute;
            left: 0;
        }
    }
}
</style>
